import { Phone } from "lucide-react";
import { Button } from "../ui/button";

const NAV_BUTTONS = [
  { id: "booking", label: "Book Now", testId: "nav-book-now" },
  { id: "meet-owner", label: "Meet Owner", testId: "nav-meet-owner" },
  { id: "pain-relief", label: "Pain Relief", testId: "nav-pain-relief" },
  { id: "fat-reduction", label: "Fat Reduction", testId: "nav-fat-reduction" },
  { id: "gym-partnerships", label: "Gym Partners", testId: "nav-gym-partnerships" },
  { id: "events-teams", label: "Sports Teams", testId: "nav-sports-teams" },
  { id: "races-track", label: "Races & Track", testId: "nav-races-track" },
  { id: "baseball", label: "Baseball", testId: "nav-baseball" },
  { id: "clinical-studies", label: "Clinical Studies", testId: "nav-clinical-studies" },
  { id: "corporate-wellness", label: "Corporate", testId: "nav-corporate-wellness" },
  { id: "chiro-pt", label: "Chiro/PT", testId: "nav-chiro-pt" },
];

export const NavHeader = ({ scrollToSection }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0318]/95 backdrop-blur-lg border-b border-purple-400/30">
      <div className="px-2 md:px-4 py-1.5">
        <a
          href="tel:8443423626"
          className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white font-bold text-xs md:text-sm py-2 rounded-md mb-1.5"
          data-testid="nav-phone"
        >
          <Phone className="w-4 h-4" />844-3ICEMAN
        </a>
        <div className="grid grid-cols-5 md:grid-cols-11 gap-1">
          {NAV_BUTTONS.map((btn) => (
            <Button
              key={btn.id}
              onClick={() => scrollToSection(btn.id)}
              size="sm"
              className="bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white font-semibold text-[7px] md:text-[10px] leading-tight py-1.5 md:py-2 h-auto rounded-sm md:rounded-md w-full"
              data-testid={btn.testId}
            >
              {btn.label}
            </Button>
          ))}
        </div>
      </div>
    </header>
  );
};
